import { useEffect, useState } from "react";
import { Store } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export function PartnersSection() {
  const { t } = useLang();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/partners").then(({ data }) => setPartners(Array.isArray(data) ? data : [])).catch(() => {});
  }, []);

  if (partners.length === 0) return null;

  return (
    <section id="partners" data-testid="partners-section" className="relative z-10 bg-[#050505] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-14 md:mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("partners.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl mt-5 leading-[1.05]">
            {t("partners.heading")}
          </h2>
          <p className="mt-4 text-zinc-400 text-base md:text-lg leading-relaxed">{t("partners.subheading")}</p>
        </Reveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {partners.map((p, i) => {
            const Card = (
              <div
                data-testid={`partner-card-${p.id}`}
                className="group h-full min-h-[130px] rounded-2xl border border-aura-border bg-aura-surface p-6 flex flex-col items-center justify-center gap-3 text-center hover:border-aura-borderhover hover:-translate-y-1 transition-[transform,border-color] duration-300"
              >
                {p.logo_url ? (
                  <img
                    src={p.logo_url}
                    alt={p.name}
                    className="max-h-14 max-w-[80%] object-contain opacity-70 grayscale group-hover:opacity-100 group-hover:grayscale-0 transition-[opacity,filter] duration-300"
                  />
                ) : (
                  <Store className="text-zinc-500 group-hover:text-white transition-colors" size={26} />
                )}
                <span className="font-display text-base md:text-lg font-semibold text-zinc-200 group-hover:text-white transition-colors">
                  {p.name}
                </span>
              </div>
            );
            return (
              <Reveal key={p.id} delay={Math.min(i * 0.05, 0.4)}>
                {p.url ? (
                  <a href={p.url} target="_blank" rel="noopener noreferrer" className="block h-full">{Card}</a>
                ) : Card}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
